import { useViewTableData, skeletonFactory } from 'shared';
import { tobaccoProducts } from 'services';

const productsDummy = skeletonFactory.tobaccoProducts();

export function useTobaccoProductsPaginated() {
  const {
    data: productsData,
    get: getProducts,
    deleteElements: deleteProducts,
    errorInfo: getDeleteErrorKey,
    setErrorInfo
  } = useViewTableData({
    service: tobaccoProducts,
    paginatedSkeleton: productsDummy
  });

  return {
    products: productsData,
    getProducts,
    deleteProducts,
    errorInfo: getDeleteErrorKey,
    setErrorInfo
  };
}
